<template>
  <div>
    <div class="banner_box">
     <joinpartbanner></joinpartbanner>
    </div>
    <div class="detail_box">
      <div class="join_detail">
        <div class="join_title">
          {{$t("join.intern")}}
        </div>
        <div class="company_name">
          {{$t("join.companyname")}}
        </div>
        <div class="work_property">
          <span class="work_property1">{{$t("join.worknature")}}<span class="work_property2">{{$t("join.fulltime")}}</span></span>
          <span class="work_property1">{{$t("join.salary")}}<span class="work_property2">{{$t("join.internmoney")}}</span></span>
          <span class="work_property1">{{$t("join.education")}}<span class="work_property2">{{$t("join.specialist")}}</span></span>
          <span class="work_property1">{{$t("join.workyears")}}<span class="work_property2">{{$t("join.unlimited")}}</span></span>
        </div>
        <div class="job_content">
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positiondescribe")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>辅助工程师基于unity3D引擎进行开发，实现相关功能编码，测试，发布</p>
                </li>
                <li>
                  <p> 辅助工程师对接美术资源（3D模型等），调整特效</p>
                </li>
                <li>
                  <p>其他项目中涉及到的VR技术的研发支持</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positionclaim")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>大专以上学历，计算机，设计，电子信息等优秀理工科等相关专业优先考虑</p>
                </li>
                <li>
                  <p>熟悉unity3D开发环境，C#语言，Shader编程或3DMax的优先</p>
                </li>
                <li>
                  <p>对虚拟现实，视景仿真有高度的热情和爱好</p>
                </li>
                <li>
                  <p>有较强的学习能力和解决问题的能力</p>
                </li>
                <li>
                  <p>具有良好的团队意识及沟通能力，有独立解决问题的能力</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="job_location">
          {{$t('join.location')}}
        </div>
        <div class="job_return" align="center">
          <div @mouseenter="enter" @mouseleave="leave" :class="isflag==true?'job_return_div1':'job_return_div'"><a
              @click="setroters('/join/index')">返回列表</a></div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import joinpartbanner from "@/components/contentcoms/joincontentcoms/joinpartbanner";
  export default {
    name: "intern",
    components: {
      joinpartbanner
    },
     data() {
      return {
        isflag: false
      }
    },
    methods: {
      setroters(src) {
        this.$router.push(src);
      },
      enter: function () {
        this.isflag = true;
      },
      leave: function () {
        this.isflag = false;
      }
    }
  }
</script>

<style scoped>
  .detail_box{
    margin: 0 auto;
    width: 1200px;
    padding-top: 50px;
  }
  .join_title{
    font-size: 24px;
    color: #333333;
    padding-bottom: 20px;
  }
  .company_name{
    font-size: 14px;
    color: #B6B6B6;
    text-align: left;
    padding-bottom: 16px;
    border-bottom: 1px solid #FBFBFB;
  }
  .work_property{
    padding: 22px 0px 22px 20px;
    text-align: left;
    border-bottom: 1px solid #FBFBFB;
  }
  .work_property1{
    font-size: 16px;
    color: #666666;
    padding-right: 110px;
  }
  .work_property2{
    font-size: 16px;
    color: #333333;
  }
  .job_content{
    padding-bottom: 30px;
    border-bottom: 1px solid #FBFBFB;
  }
  .job_describe{
    text-align: left;
    padding: 30px 0px 30px 20px;
  }
  .job_describe_ul{
    padding-top: 18px;
  }
  .job_describe_ul ul {
    color: #2E79BE;
  }
  .job_describe_ul p {
    font-size: 16px;
    color: #666666;
  }
  .job_location{
    text-align: left;
    font-size: 16px;
    color: #333333;
    padding: 20px 0px 20px 20px;
    border-bottom: 1px solid #FFFFFF;
  }
  .job_return{
    margin-top: 10px;
  }

  .job_return a{
    font-size: 14px;

  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/intern.vue